import { Injectable } from '@angular/core';
import { Permission } from '@shared/data-access';

@Injectable()
export class PermissionService {
  private permissions: Set<Permission> = new Set();

  setPermissions(permissions: Permission[]) {
    this.permissions = new Set(permissions);
  }

  hasPermission(permission: Permission): boolean {
    return this.permissions.has(permission);
  }

  hasAnyPermission(permissions: Permission[]): boolean {
    return permissions.some((permission) => this.permissions.has(permission));
  }

  hasAllPermissions(permissions: Permission[]): boolean {
    return permissions.every((permission) => this.permissions.has(permission));
  }
}
